(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Bundle quantity selector
  (function () {
    var sid      = '{{ section.id }}';
    var wrap     = document.getElementById('ad-bundle-opts-' + sid);
    if (!wrap) return;

    var bundle   = document.getElementById('ad-bundle-' + sid);
    var unitPrice = parseInt(bundle.dataset.price, 10);
    var savings  = document.getElementById('ad-bundle-savings-' + sid);
    var opts     = wrap.querySelectorAll('.ad-bundle__opt');
    var currency = '{{ shop.currency }}';

    function fmt(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency', currency: currency
      });
    }

    function renderPrices() {
      opts.forEach(function (btn) {
        var qty  = parseInt(btn.dataset.qty, 10);
        var free = parseInt(btn.dataset.free, 10);
        var payEl = btn.querySelector('.ad-bundle__pay');
        var perEl = btn.querySelector('.ad-bundle__per');
        if (payEl) payEl.textContent = fmt(unitPrice * qty);
        if (perEl && free > 0) {
          perEl.textContent = fmt(Math.round(unitPrice * qty / (qty + free))) + ' / box';
        }
      });
    }

    function select(btn) {
      opts.forEach(function (o) { o.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      var qty  = parseInt(btn.dataset.qty, 10);
      var free = parseInt(btn.dataset.free, 10);
      var code = btn.dataset.code || '';

      // Update any quantity inputs on the page (native Shopify buy buttons)
      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (savings) {
        savings.textContent = free > 0
          ? 'You save ' + fmt(unitPrice * free) + ' with this bundle!'
          : '';
      }

      wrap.dataset.activeCode = code;
    }

    renderPrices();
    if (opts.length) select(opts[0]);

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    // Apply discount code silently before any add-to-cart on the page
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var code = wrap.dataset.activeCode;
        if (code) {
          fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
        }
      });
    });

    // Also hook into Shopify theme ATC buttons that use fetch (not form submit)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart], .add-to-cart-button, [name="add"]');
      if (!btn) return;
      var code = wrap.dataset.activeCode;
      if (code) {
        fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information2"]) return;
  try {
    
  // Bundle quantity selector
  (function () {
    var sid      = '{{ section.id }}';
    var wrap     = document.getElementById('ad-bundle-opts-' + sid);
    if (!wrap) return;

    var bundle   = document.getElementById('ad-bundle-' + sid);
    var unitPrice = parseInt(bundle.dataset.price, 10);
    var savings  = document.getElementById('ad-bundle-savings-' + sid);
    var opts     = wrap.querySelectorAll('.ad-bundle__opt');
    var currency = '{{ shop.currency }}';

    function fmt(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency', currency: currency
      });
    }

    function renderPrices() {
      opts.forEach(function (btn) {
        var qty  = parseInt(btn.dataset.qty, 10);
        var free = parseInt(btn.dataset.free, 10);
        var payEl = btn.querySelector('.ad-bundle__pay');
        var perEl = btn.querySelector('.ad-bundle__per');
        if (payEl) payEl.textContent = fmt(unitPrice * qty);
        if (perEl && free > 0) {
          perEl.textContent = fmt(Math.round(unitPrice * qty / (qty + free))) + ' / box';
        }
      });
    }

    function select(btn) {
      opts.forEach(function (o) { o.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      var qty  = parseInt(btn.dataset.qty, 10);
      var free = parseInt(btn.dataset.free, 10);
      var code = btn.dataset.code || '';

      // Update any quantity inputs on the page (native Shopify buy buttons)
      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (savings) {
        savings.textContent = free > 0
          ? 'You save ' + fmt(unitPrice * free) + ' with this bundle!'
          : '';
      }

      wrap.dataset.activeCode = code;
    }

    renderPrices();
    if (opts.length) select(opts[0]);

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    // Apply discount code silently before any add-to-cart on the page
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var code = wrap.dataset.activeCode;
        if (code) {
          fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
        }
      });
    });

    // Also hook into Shopify theme ATC buttons that use fetch (not form submit)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart], .add-to-cart-button, [name="add"]');
      if (!btn) return;
      var code = wrap.dataset.activeCode;
      if (code) {
        fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
